<span>{{getDate()}}</span>